/**
 * copyToClipboard — utilitário com fallback robusto.
 *
 * Tenta `navigator.clipboard.writeText` primeiro. Se falhar (NotAllowedError,
 * contexto inseguro, navegador antigo), cai para `document.execCommand('copy')`
 * via textarea oculto. Retorna true/false indicando sucesso.
 */
export async function copyToClipboard(text) {
  // 1) Clipboard API moderna
  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch { /* fallback abaixo */ }

  // 2) execCommand legado — funciona em mais contextos (incluindo iframes
  // restritos), mas precisa de seleção real no DOM.
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '-1000px';
    ta.style.left = '-1000px';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    ta.setSelectionRange(0, ta.value.length);
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
